import React, { useEffect, useRef, useState } from "react";

// A thick scrollbar pinned to the left edge of the central page that mirrors the
// window's right-hand scrollbar. Dragging either one scrolls the page in sync.
export default function LeftScrollMirror({ left = "16rem" }) {
  const barRef = useRef(null);
  const lock = useRef(false);
  const [h, setH] = useState(0);

  useEffect(() => {
    const sync = () => { if (barRef.current) barRef.current.scrollTop = window.scrollY; };
    const update = () => { setH(document.documentElement.scrollHeight); sync(); };
    const onWin = () => {
      if (lock.current) return;
      lock.current = true; sync(); lock.current = false;
    };
    update();
    window.addEventListener("scroll", onWin, { passive: true });
    window.addEventListener("resize", update);
    const ro = new ResizeObserver(update);
    ro.observe(document.body);
    const iv = setInterval(update, 700); // catch async content height changes
    return () => {
      window.removeEventListener("scroll", onWin);
      window.removeEventListener("resize", update);
      ro.disconnect(); clearInterval(iv);
    };
  }, []);

  const onBarScroll = () => {
    if (lock.current) return;
    lock.current = true;
    window.scrollTo(0, barRef.current.scrollTop);
    lock.current = false;
  };

  return (
    <div ref={barRef} onScroll={onBarScroll} data-testid="left-scroll-mirror"
      className="fixed top-0 bottom-0 z-30 hidden overflow-y-scroll md:block"
      style={{ left, width: "16px" }}>
      <div style={{ height: h }} />
    </div>
  );
}
